import { SearchRequestContent } from "common/types";
import { SearchResponseContent } from "common/types/search-types";

import { SearchService } from "./search-service";
import { SearchExperienceService } from "./shop-search-service";
import { UserPermissions } from "./user-permissions";

export interface ISearchService {
  Search(parameters: SearchRequestContent): Promise<SearchResponseContent>;
}

export async function createSearchService(): Promise<ISearchService> {
  if (await UserPermissions.current.hasPermissionAsync("catalogical")) {
    // Using Catalogical
    return new SearchExperienceService("itsoftware");
  } else {
    // The legacy client that connect to ITMPv1
    // TODO deprecate and remove
    return new SearchService();
  }
}
